export const COMMON_CONFIG = [
    // {
    //     selector: '.btn-facebook',
    //     type: '跳转Facebook',
    //     action: '社群板塊跳转Facebook',
    //     label: '社群板塊跳转Facebook',
    //     once: false,
    // },
    // {
    //     selector: '.btn-discord',
    //     type: '跳转Discord',
    //     action: '社群板塊跳转跳转Discord',
    //     label: '社群板塊跳转跳转Discord',
    //     once: false,
    // },
    // {
    //     selector: '.facebook',
    //     type: '跳转Facebook',
    //     action: '預約成功彈窗跳转Facebook',
    //     label: '預約成功彈窗跳转Facebook',
    //     once: false,
    // },
    // {
    //     selector: '.discord',
    //     type: '跳转Discord',
    //     action: '預約成功彈窗跳转Discord',
    //     label: '預約成功彈窗跳转Discord',
    //     once: false,
    // },
    // {
    //     selector: '.pop-pre-success',
    //     type: 'gtm元素可見性',
    //     action: '預約成功彈窗',
    //     label: '預約成功彈窗',
    //     parentDom: 'body',
    //     once: false,
    //     isPopup: true,
    // },
]

export const COMMON_STORE_CONFIG = [
    {
        selector: '.store .btn-ios',
        type: '点击预约',
        action: '首页跳转App Store',
        label: '首页跳转App Store',
        parentDom: '.container1',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.store .btn-gp',
        type: '点击预约',
        action: '首页跳转Google Play',
        label: '首页跳转Google Play',
        parentDom: '.container1',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=2] .btn-store-ios',
        type: '点击预约',
        action: '预约奖励板块跳转App Store',
        label: '预约奖励板块跳转App Store',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=2] .btn-store-gp',
        type: '点击预约',
        action: '预约奖励板块跳转Google Play',
        label: '预约奖励板块跳转Google Play',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },

    {
        selector: '.float-bottom-store[data-hash=3] .btn-store-ios',
        type: '点击预约',
        action: '世界觀板块跳转App Store',
        label: '世界觀板块跳转App Store',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=3] .btn-store-gp',
        type: '点击预约',
        action: '世界觀板块跳转Google Play',
        label: '世界觀板块跳转Google Play',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },

    {
        selector: '.float-bottom-store[data-hash=4] .btn-store-ios',
        type: '点击预约',
        action: '角色介紹板块跳转App Store',
        label: '角色介紹板块跳转App Store',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=4] .btn-store-gp',
        type: '点击预约',
        action: '角色介紹板块跳转Google Play',
        label: '角色介紹板块跳转Google Play',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=5] .btn-store-ios',
        type: '点击预约',
        action: '商店圖板块跳转App Store',
        label: '商店圖板块跳转App Store',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.float-bottom-store[data-hash=5] .btn-store-gp',
        type: '点击预约',
        action: '商店圖板块跳转Google Play',
        label: '商店圖板块跳转Google Play',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.footer .bottom-store .ios',
        type: '点击预约',
        action: '底部按鈕跳转App Store',
        label: '底部按鈕跳转App Store',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
    {
        selector: '.footer .bottom-store .gp',
        type: '点击预约',
        action: '底部按鈕跳转Google Play',
        label: '底部按鈕跳转Google Play',
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false,
    },
]

export const MB_STORE_CONFIG = [...COMMON_STORE_CONFIG]
export const PC_STORE_CONFIG = [...COMMON_STORE_CONFIG]

export const MB_CONFIG = [...COMMON_CONFIG]
export const PC_CONFIG = [...COMMON_CONFIG]
